import { INTERNAL, INTERNAL_PATH } from '../config/internal'

export const removeInternal = () => {
	// You can delete a cookie by updating its expiration time to zero.
	// From https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
	document.cookie = `${INTERNAL}; max-age=0; path=${INTERNAL_PATH}`
}
